import React from "react";
import "./leads.scss";

const rows = [
  {
    id: 1,
    issue: "Jun 2026 (Early)",
    project: "Kuching Central Mall Extension",
    state: "Sarawak",
    category: "Commercial",
    stage: "Construction",
    value: "RM120M",
    developer: "ABC Development Sdn Bhd",
    consultant: "XYZ Architect",
    contractor: "DEF Builder",
    start: "2026-07-01",
    approvedAt: "2026-06-23 10:10",
    syncedAt: "2026-06-23 10:18",
    leadScore: 85,
    aiScore: 92,
    status: "New Lead",
    assignedTo: "Unassigned",
    source: "MyBina",
  },
  {
    id: 2,
    issue: "Jun 2026 (Early)",
    project: "Miri Industrial Park Phase 3",
    state: "Sarawak",
    category: "Industrial",
    stage: "Tender",
    value: "RM80M",
    developer: "Miri Holdings",
    consultant: "KTA Architect",
    contractor: "-",
    start: "-",
    approvedAt: "2026-06-23 10:22",
    syncedAt: "2026-06-23 10:25",
    leadScore: 71,
    aiScore: 84,
    status: "Assigned",
    assignedTo: "Alex Tan",
    source: "MyBina",
  },
  {
    id: 3,
    issue: "Jun 2026 (Early)",
    project: "Samarahan Boulevard Development",
    state: "Sarawak",
    category: "Infrastructure",
    stage: "Planning",
    value: "RM250M",
    developer: "Sarawak Metro Development",
    consultant: "Urbanline Consultant",
    contractor: "-",
    start: "2027-01-15",
    approvedAt: "2026-06-23 10:40",
    syncedAt: "Pending",
    leadScore: 79,
    aiScore: 88,
    status: "New Lead",
    assignedTo: "Unassigned",
    source: "DayakDaily",
  },
  {
    id: 4,
    issue: "Jun 2026 (Mid)",
    project: "Bintulu Mixed Development Hub",
    state: "Sarawak",
    category: "Mixed Development",
    stage: "Design",
    value: "RM310M",
    developer: "Bintulu Landmark Group",
    consultant: "Nexus Design Studio",
    contractor: "-",
    start: "2026-11-01",
    approvedAt: "2026-06-23 11:05",
    syncedAt: "2026-06-23 11:10",
    leadScore: 82,
    aiScore: 90,
    status: "Contacted",
    assignedTo: "Michelle Wong",
    source: "MyBina",
  },
  {
    id: 5,
    issue: "Jun 2026 (Mid)",
    project: "Sibu Private Medical Centre",
    state: "Sarawak",
    category: "Healthcare",
    stage: "Tender",
    value: "RM95M",
    developer: "CareBuild Healthcare",
    consultant: "MedArch Planner",
    contractor: "Pending Award",
    start: "2026-09-10",
    approvedAt: "2026-06-23 11:28",
    syncedAt: "Pending",
    leadScore: 76,
    aiScore: 81,
    status: "New Lead",
    assignedTo: "Unassigned",
    source: "MyBina",
  },
  {
    id: 6,
    issue: "Jun 2026 (Late)",
    project: "Kota Samarahan Apartment Blocks",
    state: "Sarawak",
    category: "Residential",
    stage: "Construction",
    value: "RM68M",
    developer: "Premier Homes Sdn Bhd",
    consultant: "HomePlan Architect",
    contractor: "SolidBuild Construction",
    start: "2026-08-01",
    approvedAt: "2026-06-23 11:45",
    syncedAt: "2026-06-23 11:50",
    leadScore: 66,
    aiScore: 74,
    status: "Follow Up",
    assignedTo: "Jason Lee",
    source: "MyBina",
  },
  {
    id: 7,
    issue: "Jun 2026 (Late)",
    project: "Kuching Warehouse & Logistics Centre",
    state: "Sarawak",
    category: "Industrial",
    stage: "Construction",
    value: "RM42M",
    developer: "East Logistics Park",
    consultant: "Industrial Design Associates",
    contractor: "Mega Structure Works",
    start: "2026-06-30",
    approvedAt: "2026-06-23 12:02",
    syncedAt: "2026-06-23 12:05",
    leadScore: 73,
    aiScore: 79,
    status: "Assigned",
    assignedTo: "Alex Tan",
    source: "CIDB",
  },
  {
    id: 8,
    issue: "Jul 2026 (Early)",
    project: "Mukah Education Campus Upgrade",
    state: "Sarawak",
    category: "Education",
    stage: "Planning",
    value: "RM55M",
    developer: "Education Facilities Board",
    consultant: "Campus Design Consultant",
    contractor: "-",
    start: "2027-02-01",
    approvedAt: "2026-06-23 12:20",
    syncedAt: "Pending",
    leadScore: 61,
    aiScore: 68,
    status: "New Lead",
    assignedTo: "Unassigned",
    source: "Tender Portal",
  },
];

const getScoreClass = (score) => {
  if (score >= 80) return "score score--high";
  if (score >= 60) return "score score--medium";
  return "score score--low";
};

const getStatusClass = (status) => `status status--${status.toLowerCase().replace(/\s+/g, "-")}`;

export default function LeadsPage() {
  return (
    <div className="leads-page">
      <div className="leads-page__topbar">
        <div>
          <h2>Leads</h2>
          <p>Manage approved opportunities, assign ownership, and sync selected leads to the main system.</p>
        </div>
      </div>

      <div className="leads-page__filters">
        <input placeholder="Search lead, developer, consultant..." />
        <select><option>All Issues</option><option>Jun 2026 Early</option><option>Jun 2026 Mid</option><option>Jun 2026 Late</option></select>
        <select><option>All States</option><option>Sarawak</option><option>Sabah</option><option>Selangor</option></select>
        <select><option>All Categories</option><option>Commercial</option><option>Industrial</option><option>Residential</option><option>Infrastructure</option></select>
        <select><option>All Stages</option><option>Planning</option><option>Design</option><option>Tender</option><option>Construction</option></select>
        <select><option>All Status</option><option>New Lead</option><option>Assigned</option><option>Contacted</option><option>Follow Up</option></select>
      </div>

      <div className="leads-page__table-wrapper">
        <table className="leads-page__table">
          <thead>
            <tr>
              <th className="sticky-col">Actions</th>
              <th>Project / Opportunity</th>
              <th>AI Score</th>
              <th>Status</th>
              <th>Stage</th>
              <th>Project Value</th>
              <th>State</th>
              <th>Developer</th>
              <th>Synced to EMS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <React.Fragment key={row.id}>
                <tr className={`record-row record-row--main record-row--${index % 2 === 0 ? "even" : "odd"}`}>
                  <td className="sticky-col actions-cell" rowSpan={2}>
                    <div className="action-buttons" aria-label={`Actions for ${row.project}`}>
                      <button type="button" className="icon-button" title="View" aria-label="View">👁</button>
                      <button type="button" className="icon-button" title="Edit" aria-label="Edit">✎</button>
                      <button type="button" className="icon-button icon-button--revert" title="Revert to News" aria-label="Revert to News">↩</button>
                      <button type="button" className="icon-button icon-button--sync" title="Sync to Main System" aria-label="Sync to Main System">⇄</button>
                    </div>
                  </td>
                  <td className="project-cell">
                    <strong>{row.project}</strong>
                    <span>{row.category}</span>
                  </td>
                  <td><span className={getScoreClass(row.aiScore)}>{row.aiScore}</span></td>
                  <td><span className={getStatusClass(row.status)}>{row.status}</span></td>
                  <td>{row.stage}</td>
                  <td><strong>{row.value}</strong></td>
                  <td>{row.state}</td>
                  <td>{row.developer}</td>
                  <td>{row.approvedAt}</td>
                </tr>
                <tr className={`record-row record-row--detail record-row--${index % 2 === 0 ? "even" : "odd"}`}>
                  <td colSpan={8}>
                    <div className="detail-grid">
                      <div><label>Issue</label><strong>{row.issue}</strong></div>
                      <div><label>Consultant</label><strong>{row.consultant}</strong></div>
                      <div><label>Contractor</label><strong>{row.contractor}</strong></div>
                      <div><label>Construction Start</label><strong>{row.start}</strong></div>
                      <div><label>Lead Score</label><strong>{row.leadScore}</strong></div>
                      <div><label>Assigned To</label><strong>{row.assignedTo}</strong></div>
                      <div><label>Source</label><strong>{row.source}</strong></div>
                      <div><label>Last Synced</label><strong>{row.syncedAt}</strong></div>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
